import { useEffect, useState } from "react";
import { FiX } from "react-icons/fi";
import { BtnDefault } from "../../../../../../components/buttons/BtnDefault";
import { InputDefault } from "../../../../../../components/forms/InputDefault";
import { PppoeUserService } from "../../../../../../services/PppoeUserService";
import { SelectProfile } from "../../../../../../components/forms/selects/SelectProfile";

export const PppoeServiceUpdate = ({
  data,
  open,
  setOpen,
  refreshData,
}) => {
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    profile_id: "",
    price: 0,
    discount: 0,
    ppn: 0,
    registration_date: "",
  });

  const [error, setError] = useState({
    profile_id: "",
    discount: "",
    ppn: "",
    registration_date: "",
  });

  useEffect(() => {
    if (data && open) {
      setFormData({
        profile_id: data?.service?.profile?.id || "",
        price: data?.service?.profile?.id || 0,
        discount: data?.service?.discount || 0,
        ppn: data?.service?.ppn || 0,
        registration_date: data?.service?.registration_date?.split(" ")[0] || "",
      });
      setError({
        profile_id: "",
        discount: "",
        ppn: "",
        registration_date: "",
      });
    }
  }, [data, open]);

  const handleChange = (e) => {
    const { id, value } = e.target;

    setFormData((prev) => ({ ...prev, [id]: value }));
    setError((prev) => ({ ...prev, [id]: "" }));
  };

  const validateLocal = () => {
    const errs = { profile_id: "", discount: "", ppn: "", registration_date: "" };
    let valid = true;

    if (!formData.profile_id) {
      errs.profile_id = "Paket/Profile wajib dipilih";
      valid = false;
    }

    const discount = Number(formData.discount);
    if (isNaN(discount) || discount < 0) {
      errs.discount = "Diskon tidak boleh negatif";
      valid = false;
    }

    const ppn = Number(formData.ppn);
    if (isNaN(ppn) || ppn < 0 || ppn > 100) {
      errs.ppn = "PPN harus antara 0% dan 100%";
      valid = false;
    }

    setError(errs);
    return valid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateLocal()) return;

    setLoading(true);

    try {
      await PppoeUserService.serviceUpdate({
        data: {
          profile_id: formData.profile_id,
          price: Number(formData.price),
          discount: Number(formData.discount) || 0,
          ppn: Number(formData.ppn) || 0,
          registration_date: formData.registration_date || null,
        },
        id: data.id,
      });

      refreshData?.();
      setOpen(false);
    } catch (err) {
      if (err.response?.data?.errors) {
        const s = err.response.data.errors;
        setError((prev) => ({
          profile_id: s.profile_id?.[0] || prev.profile_id,
          discount: s.discount?.[0] || prev.discount,
          ppn: s.ppn?.[0] || prev.ppn,
          registration_date: s.registration_date?.[0] || prev.registration_date,
        }));
      }
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  /* ── Helper format Rupiah ── */
  const formatRupiah = (val) => {
    const num = Number(val) || 0;
    return "Rp " + num.toLocaleString("id-ID");
  };

  /* ── Hitung total setelah diskon + PPN ── */
  const price = Number(formData.price) || 0;
  const discount = Number(formData.discount) || 0;
  const ppn = Number(formData.ppn) || 0;
  const afterDiscount = Math.max(0, price - discount);
  const total = afterDiscount + (afterDiscount * ppn / 100);

  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="bg-slate-800 w-full max-w-lg rounded-2xl shadow-2xl overflow-visible">

        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-white/10">
          <h3 className="text-lg font-bold text-white">
            Update Layanan Pelanggan
          </h3>
          <button
            onClick={() => setOpen(false)}
            className="p-2 hover:bg-white/10 rounded-full transition-colors"
          >
            <FiX size={20} className="text-white" />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="p-6 space-y-4">

          {/* Profile / Paket */}
          <SelectProfile
            label="Profile / Paket"
            placeholder="Silahkan pilih paket..."
            value={formData.profile_id}
            setValue={(value) =>
              setFormData((prev) => ({ ...prev, profile_id: value }))
            }
            setPrice={(price) =>
              setFormData((prev) => ({ ...prev, price: Number(price) || 0 }))
            }
            error={error.profile_id}
          />

          {/* Harga Paket */}
          <InputDefault
            id="price"
            label="Harga Paket"
            type="text"
            placeholder="0"
            value={formatRupiah(formData.price)}
            disabled={true}
          />

          {/* Diskon */}
          <InputDefault
            id="discount"
            label="Diskon"
            type="number"
            placeholder="0"
            min="0"
            value={formData.discount}
            onChange={handleChange}
            error={error.discount}
          />

          {/* PPN */}
          <div>
            <InputDefault
              id="ppn"
              label="PPN"
              type="number"
              placeholder="0"
              min="0"
              max="100"
              value={formData.ppn}
              onChange={handleChange}
              error={error.ppn}
            />
            <p className="text-[11px] text-slate-500 mt-1 ml-1">
              Dalam persen (0–100%)
            </p>
          </div>

          {/* Tanggal Instalasi */}
          <InputDefault
            id="registration_date"
            label="Tanggal Instalasi"
            type="date"
            value={formData.registration_date}
            onChange={handleChange}
            error={error.registration_date}
          />

          {/* Ringkasan harga */}
          <div
            className="rounded-xl p-4 space-y-2"
            style={{
              background: "rgba(15, 23, 42, 0.6)",
              border: "1px solid rgba(51, 65, 85, 0.3)",
            }}
          >
            <div className="flex justify-between text-sm">
              <span className="text-slate-400">Harga Paket</span>
              <span className="text-slate-300">{formatRupiah(price)}</span>
            </div>
            {discount > 0 && (
              <div className="flex justify-between text-sm">
                <span className="text-slate-400">Diskon</span>
                <span className="text-red-400">- {formatRupiah(discount)}</span>
              </div>
            )}
            {ppn > 0 && (
              <div className="flex justify-between text-sm">
                <span className="text-slate-400">PPN ({ppn}%)</span>
                <span className="text-slate-300">+ {formatRupiah(afterDiscount * ppn / 100)}</span>
              </div>
            )}
            <div
              className="flex justify-between text-sm font-semibold pt-2"
              style={{ borderTop: "1px solid rgba(51, 65, 85, 0.3)" }}
            >
              <span className="text-slate-200">Total</span>
              <span className="text-cyan-400">{formatRupiah(total)}</span>
            </div>
          </div>

          {/* Footer */}
          <div className="flex gap-3 pt-4 border-t border-white/10">
            <button
              type="button"
              disabled={loading}
              onClick={() => setOpen(false)}
              className="flex-1 px-4 py-2.5 border border-white text-white rounded-xl font-semibold hover:bg-white/10 disabled:opacity-50 transition-colors"
            >
              Batal
            </button>

            <BtnDefault
              type="submit"
              disabled={loading}
              className="flex-1 justify-center py-2.5"
            >
              {loading ? "Sedang Menyimpan..." : "Simpan"}
            </BtnDefault>
          </div>
        </form>
      </div>
    </div>
  );
};